var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 31,
    viewBox: "0 0 34 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8409 30.999H11.1591C4.9973 30.999 0 26.14 0 20.1486V10.8495C0 4.8581 4.9973 -0.000976562 11.1591 -0.000976562H22.8409C29.0027 -0.000976562 34 4.8581 34 10.8495V20.1486C34 26.14 29.0027 30.999 22.8409 30.999Z",
    fill: "#d8e152"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4537 5.12488H6.33911V26.0708H12.4537V5.12488Z",
    fill: "#231E28"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2795 11.2402L27.2795 5.12402L6.33911 5.12402L6.33911 11.2402L27.2795 11.2402Z",
    fill: "#231E28"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2348 26.0665C24.0209 26.0665 27.09 22.9966 27.09 19.2095C27.09 15.4225 24.0209 12.3525 20.2348 12.3525C16.4488 12.3525 13.3796 15.4225 13.3796 19.2095C13.3796 22.9966 16.4488 26.0665 20.2348 26.0665Z",
    fill: "#231E28"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/HomeIcon.909167d0af9502b175106dd3f3659395.svg";
export { ForwardRef as ReactComponent };